import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import { fileAndFolder } from "types/Models/documents";
import { getFileType } from "utils/getFileType";
import { RecycleBinActions } from "./RecycleBinActions";
import { RecycleBinBulkActions } from "./RecycleBinBulkActions";
import { FileFolderCard } from "../folderAndFileSection";
import ToolTip from "components/design/toolTip";
import { useMemo, useState } from "react";

type RecycleBinGridViewProps = {
  items: fileAndFolder[];
  groupId: string;
};

export const RecycleBinGridView = ({
  items,
  groupId,
}: RecycleBinGridViewProps) => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const selectedItems = useMemo(() => {
    return items.filter((item) => selectedIds.has(item.uuid));
  }, [items, selectedIds]);

  const selectedItemLength = selectedItems.length;
  const isItemSelected = selectedItemLength > 0;

  const handleCheckBoxChange = (uuid: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(uuid)) {
        next.delete(uuid);
      } else {
        next.add(uuid);
      }
      return next;
    });
  };

  const handleItemClick = (uuid: string) => {
    setSelectedIds(new Set([uuid]));
  };

  const clearSelection = () => setSelectedIds(new Set());

  return (
    <div className="t-flex t-flex-col t-gap-4">
      {selectedItemLength > 0 && (
        <RecycleBinBulkActions
          selectedItems={selectedItems}
          groupId={groupId}
          onClearSelection={clearSelection}
        />
      )}
      <div className="t-flex t-flex-wrap t-gap-6 t-w-full">
        {items.map(({ uuid, name, file_type, type, is_private }) => {
          const fileType = getFileType(file_type, type, false, is_private);
          const isChecked = selectedIds.has(uuid);

          return (
            <FileFolderCard
              key={uuid}
              isChecked={isChecked}
              thumbnailFileId={null}
              isAlreadySelected={false}
              dropActive={false}
              name={
                <ToolTip text={name}>
                  <span className="t-line-clamp-1">{name}</span>
                </ToolTip>
              }
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                handleItemClick(uuid);
              }}
              checkBox={
                <div className="t-w-6 t-h-6 t-flex t-items-center t-justify-center">
                  <Checkbox
                    title={name}
                    onChange={() => handleCheckBoxChange(uuid)}
                    onClick={(e) => e.stopPropagation()}
                    checked={isChecked}
                  />
                </div>
              }
              actionDropDown={
                <RecycleBinActions
                  fileId={uuid}
                  groupId={groupId}
                  selectedItemLength={selectedItemLength}
                />
              }
              fileType={fileType}
              selected={isChecked}
              isItemSelected={isItemSelected}
            />
          );
        })}
      </div>
    </div>
  );
};
